import axios from "_u/axios"

// 品类管理列表
export const catalogList = body => {
    return axios.post("api/merch/catalog/list", body)
}
// 品类管理新增
export const catalogAdd = body => {
    return axios.post("api/merch/catalog/add", body)
}

// 品类管理启用/禁用
export const catalogEnable = id => {
    return axios.post("api/merch/catalog/enable", { id })
}

// 品类管理更新
export const catalogUpdate = body => {
    return axios.post("api/merch/catalog/update", body)
}

// 品类管理查看
export const catalogView = id => {
    return axios.post("api/merch/catalog/view", { id })
}

export const chooseList = () => {
    return axios.post("api/merch/catalog/chooseList")
}


// 商品管理列表
export const merchList = body => {
    return axios.post("api/merch/info/list", body)
}

// 商品管理列表(带分页)
export const merchChooseList = body => {
    return axios.post("api/merch/info/chooseList", body)
}

// 商品管理新增
export const merchAdd = body => {
    return axios.post("api/merch/info/add", body)
}

// 商品管理上架/下架
export const merchEnable = id => {
    return axios.post("api/merch/info/enable", { id })
}

// 商品管理更新
export const merchUpdate = body => {
    return axios.post("api/merch/info/update", body)
}

// 商品管理查看
export const merchView = id => {
    return axios.post("api/merch/info/view", { id })
}